import { useTranslation } from '@pancakeswap/localization'
import { Box, Modal, useToast, Button, Input, Text } from '@pancakeswap/uikit'
import { useWeb3LibraryContext, useWeb3React } from '@pancakeswap/wagmi'
import CountUp from 'react-countup'
import useTheme from 'hooks/useTheme'
import { useState } from 'react'
import styled from 'styled-components'
import { trendyColors } from 'style/trendyTheme'
import useConfirmTransaction from 'hooks/useConfirmTransaction'
import { useCallWithMarketGasPrice } from 'hooks/useCallWithMarketGasPrice'
import { ToastDescriptionWithTx } from 'components/Toast'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
// import { ChainId } from '../../../../../../../packages/swap-sdk/src/constants'
// import { ClaimPoolModalProps } from './type'
import { Mine } from '../util'
import { useBalance, useSigner } from 'wagmi'
import { formatBigNumber } from 'utils/formatBalance'
import { formatEther } from '@ethersproject/units'
import BigNumber from 'bignumber.js'
import { getFullDecimalMultiplier } from 'utils/getFullDecimalMultiplier'
import { color } from 'configs/color'
import { getContract } from 'utils/contractHelpers'
import addresses from 'config/constants/contracts'
import tokenCST from 'config/abi/tokenCore.json'
import { ButtonStake } from 'components/ButtonStake'
// STYLE
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 300px;
  justify-content: center;
  gap: 1em;
  /* padding: 0 10px; */
`
const ClaimAmount = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const depositModal = {}
const depositInput = {
  borderRadius: '10px',
}
const ThreeDots = styled.p`
  @keyframes blinkdot {
    0% {
      opacity: 0.2;
    }
    20% {
      opacity: 1;
    }
    100% {
      opacity: 0.2;
    }
  }
  &.loading span {
    animation-name: blinkdot;
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
  }
  &.loading span:nth-child(2) {
    animation-delay: 0.2s;
  }
  &.loading span:nth-child(3) {
    animation-delay: 0.4s;
  }
`
const Error = styled.span`
  margin: -0.5em 0 1em;
  color: ${trendyColors.ORANGE};
  font-size: 18px;
`
const ButtonMax = styled(Button)`
  position: absolute;
  top: 5px;
  right: 10px;
  height: 30px;
  color: white;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid var(--gradient-light, rgba(255, 255, 255, 0.47));
  background: var(--V, linear-gradient(90deg, #ffbd33 0%, #ff8000 100%));
`
const InputAmount = styled(Input)`
  width: 378px;
  border-radius: 36px;
  border: 1px solid #3749aa;
  background: #fff;
  backdrop-filter: blur(5px);
  height: 20px;
  padding: 20px 16px;
  color: #fffff;
`

const SendTrendModal = ({
  onDismiss,
  mine,
}: {
  // onSuccess: (dataModal) => void
  onDismiss: () => void
  mine: Mine
}) => {
  const { callWithMarketGasPrice } = useCallWithMarketGasPrice()
  const [confirmedTxHash, setConfirmedTxHash] = useState('')
  const { t } = useTranslation()
  const { data: signer } = useSigner()
  const CHAIN_ID = Number(process.env.NEXT_PUBLIC_DEFAULT_CHAIN)
  const { toastSuccess, toastError } = useToast()
  const [isValidAmount, setIsValidAmount] = useState(true)
  const tokenCSTCT = getContract({ address: addresses.tokenCore[CHAIN_ID], abi: tokenCST, chainId: CHAIN_ID, signer })
  const { chainId } = useActiveWeb3React()
  const date = Math.floor(new Date().getTime() / 1000)
  const [address, setAddress] = useState('')
  const [amount, setAmount] = useState('')
  const [valueAmount, setValueAmount] = useState(0)
  const [checkError, setCheckError] = useState(false)
  const { account } = useActiveWeb3React()
  const [inValid, setInvalid] = useState(false)
  const balance = Number(mine.balanceCST)
  const amountMax = Number(mine.balanceCST)
  const { isConfirming, handleConfirm } = useConfirmTransaction({
    onConfirm: () => {
      return callWithMarketGasPrice(tokenCSTCT, 'transfer', [address], [amount])
    },

    onSuccess: async ({ receipt }) => {
      setConfirmedTxHash(receipt.transactionHash)
      toastSuccess(t('Send TREND successfully !'), <ToastDescriptionWithTx txHash={receipt.transactionHash} />)
      onDismiss()
    },
  })
  const handleCheck = () => {
    if (address === '') {
      setCheckError(true)
    } else {
      handleConfirm()
    }
  }
  const onChange = (e) => {
    setAddress(e)
    setCheckError(false)
  }
  // const changeAmount = (e) => {
  //   setAmount(Number(new BigNumber(e).times(getFullDecimalMultiplier(18)).toString()))
  //   setValueAmount(e)
  // }
  const setAmountMax = () => {
    setAmount(new BigNumber(balance).times(getFullDecimalMultiplier(18)).toString())
    setValueAmount(amountMax)
  }
  const min = 0
  const max = Number(balance)
  const handleInputChange = (e) => {
    if (!e) {
      setAmount('')
      setValueAmount(0)
      setInvalid(true)
      return
    }
    if (!Number.isNaN(+e)) {
      const val = String(Math.max(min, Math.min(max, Number(e))))
      setAmount(new BigNumber(val).times(getFullDecimalMultiplier(18)).toString())
      // console.log(new BigNumber(e).times(getFullDecimalMultiplier(18)).toString());
      setValueAmount(Number(val))
      setInvalid(false)
    }
  }
  return (
    <Modal
      style={{
        width: '500px',
        boxShadow: '0px 4px 16px 0px rgba(17, 10, 65, 0.36)',
        backdropFilter: 'blur(50px)',
        borderRadius: '20px',
        border: '1px solid var(--border, #E86E00)',

        background: '#402D17',
      }}
      title={''}
      onDismiss={onDismiss}
      hideCloseButton={false}
      borderRadius={25}
      width="800px"
      bodyPadding="0 10px 30px"
    >
      <Wrapper>
        <Text fontSize="32px" fontWeight="700">
          SEND CST
        </Text>
        <ClaimAmount>
          <Text fontSize="18px">To</Text>
          <InputAmount
            style={{ fontSize: '16px', borderRadius: '12px', color: '#202020' }}
            value={address}
            onChange={(e) => onChange(e.target.value)}
          />
        </ClaimAmount>
        {checkError === true ? <Error>You do not enter an address !!!</Error> : null}
        <ClaimAmount>
          <Text fontSize="18px">Amount</Text>
          <div style={{ position: 'relative' }}>
            <InputAmount
              style={{ fontSize: '16px', borderRadius: '12px', color: '#202020' }}
              value={valueAmount}
              onChange={(e) => handleInputChange(e.target.value)}
            />
            <ButtonMax onClick={setAmountMax}>Max</ButtonMax>
          </div>
        </ClaimAmount>
        {inValid === true ? <Error>Please enter the value !!!</Error> : null}
        {/* {amount > balance ? <Error>You don &#39;t have enough Trend to send !!</Error> : null} */}
        <ButtonStake
          variant={'danger'}
          width="180px"
          disabled={isConfirming || (!isValidAmount ? true : false) || inValid === true}
          onClick={handleCheck}
        >
          {isConfirming ? (
            <ThreeDots className="loading">
              Sending<span>.</span>
              <span>.</span>
              <span>.</span>
            </ThreeDots>
          ) : (
            'Send'
          )}
        </ButtonStake>
      </Wrapper>
    </Modal>
  )
}

export default SendTrendModal
